

































import { Prop, Component, Vue } from 'vue-property-decorator';
import {
  getSectionsWithRowsFromInputValues,
  getSummaryValues,
  getSummaryValuesPriceEnabled,
} from '@getaccept/editor-lib/src/helpers/pricing-table/editor-node-pricing-table.helper';
import type { IPricingTable, IField, IMergeValues, EContext } from '@getaccept/editor-lib';
import type { IEditorRecipientInput } from '@lib-shared/types/editor-recipient-input';
import type { IRecipient } from '@lib-shared/types/Recipient';
import { EBlockWidth } from '@getaccept/editor-lib';
import PricingTableSection from './PricingTableSection.vue';
import PricingTablePriceSummary from './PricingTablePriceSummary.vue';

@Component({
  components: {
    PricingTablePriceSummary,
    PricingTableSection,
  },
  data: () => ({
    getSectionsWithRowsFromInputValues,
    getSummaryValues,
    getSummaryValuesPriceEnabled,
  }),
})
export default class EditorNodePricingTable extends Vue {
  @Prop() node: IPricingTable;
  @Prop() mergeValues: IMergeValues;
  @Prop() allEditorFields: IField[];
  @Prop() allCustomTags: IField[];
  @Prop() blockWidthClass: EBlockWidth;
  @Prop() recipientInput: IEditorRecipientInput[];
  @Prop() recipient: IRecipient;
  @Prop() context: EContext;

  get isBlockWidthSmall(): boolean {
    return (
      this.blockWidthClass === EBlockWidth.XXSmall || this.blockWidthClass === EBlockWidth.XSmall
    );
  }
}
